// extracted by mini-css-extract-plugin
export default {"MemberCard":"styles_MemberCard__iTO0U","imageContainer":"styles_imageContainer__lxRZa","noPhoto":"styles_noPhoto__LnPZO"};